// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { BasicUserInfo, DecodedIDTokenPayload } from "@asgardeo/auth-spa";
export type stateType = "failed" | "success" | "loading" | "idle";

export interface AuthState {
  status: State;
  mode: "active" | "maintenance";
  statusMessage: string | null;
  isAuthenticated: boolean;
  userInfo: BasicUserInfo | null;
  decodedIdToken: DecodedIDTokenPayload | null;
  roles: string[];
}

export interface AuthData {
  userInfo: BasicUserInfo;
  idToken: string;
  decodedIdToken: DecodedIDTokenPayload;
}

export interface Employee {
  workEmail: string;
  firstName: string;
  lastName: string;
  jobBand: number;
  employeeThumbnail: string;
}

export interface Header {
  title: string;
  size: number;
  align: "left" | "right" | "center";
}

export interface BankAccount {
  accountId: number;
  netSuiteInternalId: string | null;
  netSuiteVendorId: string | null;
  netSuitePaymentFileFormat: string | null;
  paymentMethod: string | null;
  employeeEmail: string;
  accountName: string;
  accountNumber: string;
  beneficiaryAddress: string;
  bankCode: string | null;
  bankSwiftCode: string | null;
  bankName: string | null;
  bankLocation: string | null;
  branchCode: string;
  branchName: string;
  bankAddress: string;
  effectiveFrom: string;
  accountStatus: AccountState;
  accountType: AccountType;
}

export enum ThemeMode {
  Light = "light",
  Dark = "dark",
}

export enum State {
  failed = "failed",
  success = "success",
  loading = "loading",
  idle = "idle",
  error = "error",
}

export enum AccountState {
  REQUESTED = "REQUESTED",
  ACTIVE = "ACTIVE",
  REJECTED = "REJECTED",
  INACTIVE = "INACTIVE",
}

export enum AccountType {
  SALARY = "SALARY",
  REIMBURSEMENT = "REIMBURSEMENT",
  CONSULTANCY = "CONSULTANCY",
}

export enum ThresholdTypes {
  SALARY_THRESHOLD = "SALARY_THRESHOLD",
  CONSULTANCY_THRESHOLD = "CONSULTANCY_THRESHOLD"
}


export enum ConfirmationType {
  update = "update",
  send = "send",
  upload = "upload",
  accept = "accept",
  delete = "delete",
}